import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterSportschoolPage() {
  return <ClusterPageTemplate clusterName="Sportschool" sectorName="Coaches & Consultants" sectorSlug="coaches-consultants" heroTitle="Website laten maken voor een sportschool" heroDescription="Een energieke, conversiegerichte website voor jouw gym, yogastudio of crossfit box. Wij bouwen websites die nieuwe leden aantrekken en proeflessen genereren." websiteOnderdelen={[{
    icon: 'CalendarCheckIcon',
    title: 'Lesrooster',
    description: 'Een overzichtelijk, altijd actueel rooster van alle groepslessen, trainingen en openingstijden.'
  }, {
    icon: 'FileTextIcon',
    title: 'Abonnementen',
    description: 'Heldere presentatie van de verschillende lidmaatschappen, prijzen en voorwaarden.'
  }, {
    icon: 'CameraIcon',
    title: 'Sfeer & Faciliteiten',
    description: "Laat de apparatuur, de zalen en de sfeer in de gym zien met professionele foto's en video's."
  }, {
    icon: 'UsersIcon',
    title: 'Proefles aanvragen',
    description: 'Een opvallende landingspagina speciaal ingericht om zoveel mogelijk aanvragen voor een gratis proefles te genereren.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Rooster integratie',
    description: 'Koppeling met systemen zoals SportBit, Virtuagym, Mindbody of Eversports.'
  }, {
    icon: 'FileTextIcon',
    title: 'Online inschrijven',
    description: 'Laat nieuwe leden zich direct via de website inschrijven en de eerste betaling voldoen via iDEAL.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Word gevonden wanneer mensen zoeken naar 'sportschool [jouw woonplaats]' of specifieke lessen zoals 'yoga'."
  }]} siblingClusters={[{
    name: 'Coaching',
    slug: 'coaching'
  }, {
    name: 'Consultant',
    slug: 'consultant'
  }, {
    name: 'Personal Trainer',
    slug: 'personal-trainer'
  }]} faqs={[{
    q: 'Koppelen jullie met Virtuagym of SportBit?',
    a: 'Ja, we kunnen de roosters en inschrijfmodules van vrijwel alle bekende fitness softwarepakketten naadloos integreren in de website.'
  }, {
    q: 'Hoe krijg ik meer aanvragen voor proeflessen?',
    a: "We maken de 'Gratis Proefles' knop het meest prominente element op de site en zorgen voor een extreem kort en simpel aanvraagformulier."
  }, {
    q: 'Wat kost een website voor een sportschool?',
    a: 'Een professionele, conversiegerichte website start vanaf €1.500. Dit is inclusief de integratie van jullie lesrooster en inschrijfmodule.'
  }, {
    q: 'Is de website makkelijk aan te passen?',
    a: 'Zeker. Je kunt zelf eenvoudig nieuwe lessen toevoegen, prijzen aanpassen of nieuwsberichten plaatsen via het WordPress CMS.'
  }]} data-id="element-1083" data-mp="8fsipzclylp8" />;
}